define.alias("shared/components/shared/wizard/slide/header", "calendar/components/shared/wizard/slide/header");